export default "__VITE_ASSET__CsvRg7mD__"